import { render, staticRenderFns } from "./libraryStats.vue?vue&type=template&id=6bac46b2&scoped=true"
import script from "./libraryStats.vue?vue&type=script&lang=js"
export * from "./libraryStats.vue?vue&type=script&lang=js"
import style0 from "./libraryStats.vue?vue&type=style&index=0&id=6bac46b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bac46b2",
  null
  
)

export default component.exports